import { FunctionComponent, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Routes as RouteDefinitions } from 'Config/Routes';

export const FallbackRoute: FunctionComponent = () => {
  const navigation = useNavigate();

  useEffect(() => {
    navigation(Object.values(RouteDefinitions)[0].path);
  }, []);

  return null;
};
